
import Home from '../views/Home.vue'
import Base from '../views/Base.vue'

export default {
    path: '/',
    redirect: '/login',
    name: 'Base',
    component: Base,
    children: [
        {
            path: '/home',
            name: 'Home',
            component: Home,
            meta: {
                title: '首页'
            }
        }
    ]

}

